import React, { useMemo } from 'react';
import Brushaway from '@components/Brushaway';
import { TabView } from '@ui/molecules/TabView';
import { Loader, Button } from '@ui';
import PhotoGallery from '@features/PhotoGallery';
import { translate } from '@utils/i18n';
import { customerPortalBuildingPath } from '@routes';
import { Text } from '@ui/atoms/Text';
import { useDeficiencyDetail } from '../hooks/useDeficiencies';
import DeficiencyDetailInfo from './DeficiencyDetailInfo';
import './DeficiencyDrawerStyles.scss';
const namespace = 'features.customer_portal.deficiencies.drawer';
export default function DeficiencyDrawer({ deficiencyId, onClose }) {
    const { data: deficiency, isLoading, error } = useDeficiencyDetail(deficiencyId);
    const title = useMemo(() => {
        if (!deficiency)
            return translate('title', { namespace });
        return (React.createElement("div", { className: "deficiency-drawer__header" },
            React.createElement("div", { className: "deficiency-drawer__title-row" },
                React.createElement(Text, { variant: "medium" },
                    translate('title', { namespace }),
                    " #",
                    deficiency.id),
                React.createElement(Text, { variant: "link", as: "a", target: "_blank", rel: "noopener noreferrer", href: customerPortalBuildingPath(deficiency.building.id), className: "deficiency-drawer__building-link" }, deficiency.building.name)),
            deficiency.resolutionStatus && (React.createElement("div", { className: "deficiency-drawer__status" },
                React.createElement(Text, { className: "deficiency-drawer__status-label" },
                    translate('deficiency_status', { namespace }),
                    ":"),
                React.createElement(Text, { className: "deficiency-drawer__status-badge" }, deficiency.resolutionStatus)))));
    }, [deficiency]);
    const tabs = useMemo(() => {
        if (!deficiency)
            return [];
        return [
            {
                id: 'details',
                label: translate('tabs.details', { namespace }),
                content: React.createElement(DeficiencyDetailInfo, { deficiency: deficiency })
            },
            {
                id: 'photos',
                label: translate('tabs.photos', { namespace }),
                content: (React.createElement("div", { className: "deficiency-photos-tab" },
                    React.createElement(PhotoGallery, { deficiencyId: Number(deficiency.id), isCustomerPortal: true })))
            }
        ];
    }, [deficiency]);
    const footer = (React.createElement("div", { className: "deficiency-drawer__footer" },
        React.createElement(Button, { onClick: onClose }, translate('close', { namespace: 'generic' }))));
    return (React.createElement(Brushaway, { open: true, onClose: onClose, title: title, customFooter: footer, wrapperContentClassName: "deficiency-drawer-wrapper" },
        React.createElement("div", { className: "deficiency-drawer" },
            isLoading && (React.createElement("div", { className: "deficiency-drawer__loading" },
                React.createElement(Loader, { vertical: true, title: translate('loading', { namespace: 'generic' }) }))),
            error && (React.createElement("div", { className: "alert alert-danger" },
                React.createElement(Text, null, translate('error_loading', { namespace })))),
            deficiency && React.createElement(TabView, { tabs: tabs }))));
}
